import React from 'react';
import Button from '../button/index';
import { IDeleteCartItem } from '../../../models';

interface IDeleteCartItemContent {
	item: {
		name: string;
		id: string;
		refCartId: string;
	};
	onClose: () => void;
	handleDelete: (arg: IDeleteCartItem) => void;
}

export const DeleteCartItemContent = ({
	item: { name, refCartId, id },
	onClose,
	handleDelete,
}: IDeleteCartItemContent) => {
	return (
		<div className="px-5 py-4">
			<div className="w-100 text-center my-5 text-capitalize font-semibold text-gray-900">
				Remove Item?
			</div>

			<div className="w-100 text-center my-5 font-medium text-gray-700">
				{name}
			</div>

			<div className="w-100 text-center my-5">
				<Button
					type="button"
					disabled={false}
					isBordered={true}
					styles="py-4 mx-3"
					style={{ width: '35%' }}
					onClick={() => onClose()}
				>
					No
				</Button>
				<Button
					type="button"
					disabled={false}
					style={{ width: '35%' }}
					styles="py-4"
					onClick={() => {
						handleDelete({ refCartId, productId: id, name });
						onClose();
					}}
				>
					Yes
				</Button>
			</div>
		</div>
	);
};

export default DeleteCartItemContent;
